var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ready)?_c('div',{attrs:{"id":"app","data-version":_vm.version}},[_c('router-view'),_c('notification'),_c('confirmation-modal'),_c('GettingStartedModal')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }